import React from 'react';
import { Box } from '@mui/material';
import { chatTheme } from '../../theme/chatTheme';

const TypingIndicator = () => {
  return (
    <Box sx={chatTheme.typingIndicator}>
      <Box component="span" />
      <Box component="span" />
      <Box component="span" />
    </Box>
  );
};

export default TypingIndicator;

